import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showLiveEpisode, setShowLiveEpisode] = useState(true);
  const navigate = useNavigate();

  return (
    <div 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/60d04f36f51af300c2f65260133756c5.jpg')`
      }}
    >
      {/* Live Episode Overlay */}
      {showLiveEpisode && (
        <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-black/90 backdrop-blur-sm rounded-2xl p-4 md:p-6 w-[calc(100%-2rem)] max-w-sm border border-red-600/30 z-10">
          <div className="flex items-center justify-between mb-3 md:mb-4">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 h-2 md:w-3 md:h-3 bg-red-600 rounded-full animate-pulse"></div>
              <span className="text-red-400 font-semibold text-xs md:text-sm">LIVE NOW</span>
            </div>
            <button 
              onClick={() => setShowLiveEpisode(false)}
              className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xs md:text-sm"></i>
            </button>
          </div>
          
          <div className="flex gap-2 md:gap-3 mb-3 md:mb-4">
            <img 
              src="https://i.ytimg.com/vi/Xv7YCVwdun0/hqdefault.jpg" 
              alt="Live Episode"
              className="w-12 h-9 md:w-16 md:h-12 rounded-lg object-cover object-top flex-shrink-0"
            />
            <div className="flex-1 min-w-0">
              <h4 className="text-white font-semibold text-xs md:text-sm mb-1 line-clamp-2">
                THE CHOP UP W | Kendrick Jones
              </h4>
              <p className="text-gray-400 text-xs">Episode 247 • 31:43</p>
            </div>
          </div>
          
          <div className="flex items-center gap-2 md:gap-3">
            <button 
              onClick={() => setIsPlaying(!isPlaying)}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-red-600 hover:bg-red-700 text-white rounded-full transition-colors cursor-pointer"
            >
              <i className={`${isPlaying ? 'ri-pause-fill' : 'ri-play-fill'} text-xs md:text-sm`}></i>
            </button>
            
            <div className="flex-1 bg-gray-700 rounded-full h-1.5 md:h-2 overflow-hidden">
              <div className="bg-red-600 h-full w-1/3 rounded-full"></div>
            </div>
            
            <button 
              onClick={() => window.open('https://www.youtube.com/@TheMuscleHustlePodcast', '_blank')}
              className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center bg-red-600/20 hover:bg-red-600/40 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-external-link-line text-red-400 text-xs"></i>
            </button>
          </div>
          
          <div className="mt-2 md:mt-3 flex items-center gap-2 text-xs text-gray-400">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            <span>1,247 watching now</span>
          </div>
        </div>
      )}

      <div className="w-full container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6 md:mb-8">
            <div className="text-lg md:text-xl lg:text-2xl font-bold text-gray-300 mb-2" style={{ fontFamily: '"Teko", sans-serif' }}>
              THE
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-none tracking-wider mb-3 md:mb-4" style={{ fontFamily: '"Teko", sans-serif', textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
              MUSCLE <span className="text-red-500">HUSTLE</span><br />
              <span className="text-3xl md:text-4xl lg:text-5xl">PODCAST</span>
            </h1>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold text-red-600 mb-4 md:mb-6 leading-tight">
            Where the Everyday Hustle is Respected
          </h2>
          
          <p className="text-xl md:text-2xl lg:text-3xl text-gray-200 mb-4 md:mb-6 max-w-2xl mx-auto leading-relaxed">
            Dive deep into conversations that honor The Grind. The Drive. The Hustle. 
            Join us every week for inspiring stories from extraordinary minds who Respect My Hustle.
          </p>

          <div className="flex flex-wrap gap-2 mb-6 md:mb-8 justify-center">
            <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheGrind</span>
            <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheDrive</span>
            <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#TheHustle</span>
            <span className="bg-red-600/20 text-red-400 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">#RespectMyHustle</span>
          </div>
          
          <div className="flex flex-col gap-3 md:gap-4 mb-8 md:mb-12 items-center">
            <button 
              onClick={() => window.open('https://open.spotify.com/show/0YDMrdRFUWloLaDufAsYVH?si=99uxCv_tTMKmcqP_gXkUlw', '_blank')}
              className="group flex items-center justify-center gap-2 md:gap-3 bg-red-600 hover:bg-red-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                <i className="ri-play-fill text-lg md:text-xl"></i>
              </div>
              <span className="hidden sm:inline">Play Latest Episode</span>
              <span className="sm:hidden">Play Latest</span>
            </button>
            
            <button 
              onClick={() => window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank')}
              className="flex items-center justify-center gap-2 md:gap-3 bg-transparent border-2 border-white text-white hover:bg-white hover:text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                <i className="ri-calendar-line text-lg md:text-xl"></i>
              </div>
              Subscribe Now
            </button>

            <button
              onClick={() => navigate('/store')}
              className="flex items-center justify-center gap-2 md:gap-3 bg-transparent border-2 border-red-500 text-red-400 hover:bg-red-600 hover:text-white hover:border-red-600 px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-lg md:text-xl"></i>
              </div>
              Shop Here
            </button>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 justify-center">
            <span className="text-gray-300 text-lg md:text-xl">Available on:</span>
            <div className="flex gap-3 md:gap-4 justify-center">
              <button 
                onClick={() => window.open('https://open.spotify.com/show/0YDMrdRFUWloLaDufAsYVH?si=99uxCv_tTMKmcqP_gXkUlw', '_blank')}
                className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-spotify-fill text-xl md:text-2xl text-green-500"></i>
              </button>
              <button 
                onClick={() => window.open('https://podcasts.apple.com/us/podcast/the-muscle-hustle-podcast/id1677247639', '_blank')}
                className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-apple-fill text-xl md:text-2xl text-white"></i>
              </button>
              <button 
                onClick={() => window.open('https://www.youtube.com/@themusclehustlepodcast', '_blank')}
                className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl md:text-2xl text-red-500"></i>
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
